import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
} from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { theme } from "./shared/theme";

import { Routes } from "./routes";

import "./base.scss";
import "./typography.scss";
import "./pages/article.scss";
import "./components/grid/grid.scss";
import "./components/simulation/simulation.scss";
import "./components/intro/intro.scss";
import "./components/typo-animation/typo-animation.scss";
import "./components/filter/filter.scss";
import "./components/header/header.scss";

const App = () => {
  return (
		<Suspense fallback={<div></div>}>
      <ThemeProvider theme={theme}>
        <Router>
          <Routes />
        </Router>
      </ThemeProvider>
		</Suspense>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
